import { logGreyError, logUsage } from "owa-analytics";
import { isRunningInMetaOSHub } from "owa-config";
import { scrubForPii } from "owa-config/lib/scrubForPii";
import { isGlobalFeatureEnabled } from "owa-feature-flags";
import { lazyGetContext } from "owa-metaos-app-bootstrap";
import { tryGetGlobalSettingsAccountMailboxInfo } from "owa-account-source-list-store";
import { getQueryStringParameter, hasQueryStringParameter } from "owa-querystring";
import { getNewMetaOSDeeplinkUrl } from "./getNewMetaOSDeeplinkUrl";

export async function handleMetaOSDeepLinkRedirection(): Promise<void> {
    if (!isRunningInMetaOSHub()) {
        return;
    }
    try {
        const devSubPageId = hasQueryStringParameter("devSubPageId") && isGlobalFeatureEnabled("fwk-devTools")
            ? decodeURIComponent(getQueryStringParameter("devSubPageId"))
            : null;
        const context = await lazyGetContext.importAndExecute();
        const newUrl = getNewMetaOSDeeplinkUrl(devSubPageId || context?.page.subPageId || "");
        if (newUrl) {
            logUsage("PlacesMetaOsDeepLinkRedirect", tryGetGlobalSettingsAccountMailboxInfo(), {
                contentUrl: scrubForPii(newUrl),
            });
            history.replaceState(history.state, "" /** unused (exists for browser historical reasons. check https://developer.mozilla.org/en-US/docs/Web/API/History/replaceState ) */, newUrl);
        }
    }
    catch (e) {
        logGreyError("MetaOSDeeplinkRedirect_FailedToGetDeeplinkSubpath", tryGetGlobalSettingsAccountMailboxInfo(), e as Error);
    }
}
